import { SubmissionError } from 'redux-form';
import { call, put, takeLatest, select } from 'redux-saga/effects';
import history from 'src/navigation/history';
import {
    failureType,
    handleError,
    requestType,
    resolveApiCall,
    ResolverApiFailure,
    ResolverApiSuccess,
    successType,
} from 'src/services/api-handlers/api-resolver';
import routes from '../../navigation/routes';
import {
    AuthLoginAction,
    AuthLoginCodeAction,
    AuthLogoutAction,
    AuthResetPasswordRequestAction,
    AuthUpdatePasswordAction,
    AuthCompleteRegAction,
    AuthValidateRecoveryCodeAction,
    GetProfileAction,
} from '../actions/auth-actions';
import { GetSeancesAction } from '../actions/seance-actions';
import { AuthActions, SeanceActions } from '../constants';
import { handleFetchUnconfirmed } from './seance-saga';
import UserAuthService from '../../services/user-auth';
import { push } from 'connected-react-router';
import { AuthApi } from '../../services/end-points';
import Router from '../../navigation/router';
import user from '../../services/user-auth';
import UserRole from '../../enumerables/user-role';
import { toast } from 'react-toastify';
import { StoreState } from '../reducers';
import { makeFormErrorsWithMessage } from '../../components/redux-form/utils/make-form-errors';
import { getInvoiceDocs } from '../actions/invoice-actions';
export function* handleGetProfile(action: GetProfileAction): any {
    const {
        payload: { onSuccess, onError },
        type,
    } = action;

    yield resolveApiCall(
        action,
        () => AuthApi.getProfile(),
        function* (data: any) {
            const isSupervisor = data?.payload?.userProviders && +!!data.payload.userProviders.length;

            if (user.getRoles().includes(UserRole.ROLE_ADMIN)) {
                yield put(
                    getInvoiceDocs({
                        page: 1,
                        itemsPerPage: 30,
                        filters: {
                            isApproved: false,
                        },
                    }),
                );
            }

            yield UserAuthService.setSupervisor(+isSupervisor);



        let logoutTimer: any = ()=> false;
        let confirmationTimer: any = ()=> false;

        let confirmationTime = 60000 * 5; // 5 minutes
        let confirmed = false;

        // Set the time in milliseconds after which the user will be logged out
        const logoutTime = 60000 * 30; // 30 minutes

        // Start the timer when the user logs in or performs an action
        function startLogoutTimer() {
            logoutTimer = setTimeout(showConfirmationPopup, logoutTime - confirmationTime);
        }

        // Reset the timer if the user performs an action
        function resetLogoutTimer() {
            clearTimeout(logoutTimer);
            clearTimeout(confirmationTimer);
            confirmed = false;
            localStorage.removeItem('auto-logout');

            startLogoutTimer();
        }

            // Log out the user after the timeout period
            function logout(out?: boolean) {

                // Add your code for logging out the user here
                /*if (user.getOut()) {        }*/

                let autoLogout = localStorage.getItem('auto-logout');
                if(autoLogout || out){
                    UserAuthService.logout();
                    history.push(routes.LOGOUT, {});
                }else{
                    resetLogoutTimer()
                }


                console.log('User logged out due to inactivity');
            }
        // Show the confirmation pop-up

        function showConfirmationPopup() {
            if (!confirmed) {
                // Replace this alert with your own pop-up
                confirmationTimer = setTimeout(logout, confirmationTime);
                let autoLogout = localStorage.getItem('auto-logout');
                if(!autoLogout){

                    alert('You will be automatically logged out in 5 minutes. To stay in the system, please move the mouse or do any other action.');
                    localStorage.setItem('auto-logout', 'true')
                    confirmed = true;
                }



            }
        }
            // Check if the current tab is the last open tab
            function isLastTab() {
                // Retrieve the stored tab count from localStorage
                const tabCount = localStorage.getItem('tabCount');
                return tabCount === null || tabCount === '1';
            }

// Update the tab count in localStorage
            function updateTabCount() {
                // Increment the tab count
                const tabCount = parseInt(localStorage.getItem('tabCount') || '0') + 1;
                localStorage.setItem('tabCount', tabCount.toString());
            }

// Decrease the tab count in localStorage
            function decreaseTabCount() {
                const tabCount = parseInt(localStorage.getItem('tabCount') || '0');
                if (tabCount <= 1) {
                    // Logout user when all tabs are closed
                    // Replace this with your logout logic
                    logout(true)
                } else {
                    // Decrement the tab count
                    localStorage.setItem('tabCount', (tabCount - 1).toString());
                }
            }
            // handle user close tab, update page, close browser
            window.addEventListener('beforeunload', function (event:any) {
                event.preventDefault();
                event.returnValue = '';

                if (isLastTab()) {
                    // let timeout in storage, check for update page // index.tsx
                    const timeout: any = Date.now()
                    localStorage.setItem('timeout', timeout);
                    localStorage.removeItem('tabCount');
                } else {
                    decreaseTabCount();
                }
            });
            updateTabCount();



        document.addEventListener('mousemove', resetLogoutTimer);
        document.addEventListener('keydown', resetLogoutTimer);

        // Start the logout timer when the user logs in or performs an action
        startLogoutTimer();
/*


            let t: any = setTimeout(() => {

                console.log(t, user.getOut(), 'first');

                if (user.getOut() !== t) {
                    user.setOut(t);
                    t = setTimeout(logout, 2000);
                   // t = setTimeout(logout, 60000 * 2);
                } else {
                    user.setOut(t);
                    t = setTimeout(logout, 2000);
                    //t = setTimeout(logout, 60000 * 2);
                }
            }, 60000 * 30);

            window.onload = resetTimer;
            // DOM Events
            document.onmousemove = resetTimer;
            document.onkeypress = resetTimer;




            function logout() {
                if (user.getOut()) {
                    UserAuthService.logout();

                    clearTimeout(t);
                    history.push(routes.LOGOUT, {});
                }
            }

            function resetTimer() {
                if (user.getOut()) {
                    user.setOut(0);
                }
                clearTimeout(t);
                t = setTimeout(() => {

                    console.log(t, user.getOut(), 'second');

                    if (user.getOut() !== t) {
                        user.setOut(t);
                        //t = setTimeout(logout, 60000 * 2);
                        t = setTimeout(logout, 2000);
                    } else {
                        user.setOut(t);
                        //t = setTimeout(logout, 60000 * 2);
                        t = setTimeout(logout, 2000);
                    }
                }, 60000 * 30);
            }*/

            if (onSuccess) {
                onSuccess();
                yield put({
                    type: successType(type),
                    payload: data,
                });
            }
        },
        function* (result: ResolverApiFailure) {
            yield put({
                type: failureType(type),
                payload: {},
            });
            if (result.error && result?.error?.response && result?.error?.response?.status) {
                if (onError) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                    onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}
const historyObj: any = history;
function* handleLogin(action: AuthLoginAction): Iterable<any> {
    const {
        type,
        payload: { data, callbacks },
        payload,
    } = action;
    yield put({ type: requestType(type) });

    try {
        const result: any = yield AuthApi.login(data.email, data.password)
            .catch(({ response }) => {
                return response;
            })
            .then((response) => {
                if (response?.status < 200 || response?.status >= 300) {
                    throw new Error('Incorrect email or password');
                }
                return response.data;
            });

        yield UserAuthService.setToken(result.token);

        yield put({
            type: successType(type),
            payload: result,
            sagaPayload: payload,
        });
        yield put(push(Router.generate(routes.LOGIN_CODE)));
    } catch (error) {
        yield put({
            type: failureType(type),
            error,
            sagaPayload: payload,
        });

        yield call(
            callbacks.reject,
            new SubmissionError({
                _error: error.message ?? 'Incorrect response',
            }),
        );
    }
}

function* handleLoginCode(action: AuthLoginCodeAction): Iterable<any> {
    const {
        type,
        payload: { data, callbacks },
        payload,
    } = action;

    if (!UserAuthService.getToken()) {
        yield put(push(Router.generate(routes.LOGIN_CUSTOMER)));
    }

    try {
        const result: any = yield AuthApi.loginCode(data.authCode, UserAuthService.getToken())
            .catch(({ response }) => {
                return response;
            })
            .then((response) => {
                if (response?.status < 200 || response?.status >= 300) {
                    throw new Error('Incorrect auth code');
                }
                return response.data;
            });

        // Backend issues the full token only after 2FA
        yield UserAuthService.login((result?.token || UserAuthService.getToken()) as string);

        yield put({
            type: successType(type),
            payload: result,
            sagaPayload: payload,
        });

        yield call(callbacks.resolve);
        const actionSeance: GetSeancesAction = {
            type: SeanceActions.FETCH_UNCONFIRMED_SEANCES,
            payload: {},
        };

        const actionUser: GetProfileAction = {
            type: AuthActions.AUTH_GET_PROFILE,
            payload: {},
        };
        yield call(handleGetProfile, actionUser);

        if (user.getRoles().includes(UserRole.ROLE_ADMIN)) {
            if (historyObj?.location?.state?.backUrl) {
                yield put(push(Router.generate(historyObj?.location?.state?.backUrl)));
            } else {
                yield put(push(Router.generate(routes.DASHBOARD)));
            }
        } else {
            const dataUser: any = yield select((state: StoreState) => state.auth.data);

            if (dataUser.id && dataUser?.userProviders && !dataUser.userProviders.length) {
                if (historyObj?.location?.state?.backUrl) {
                    yield put(push(Router.generate(historyObj?.location?.state?.backUrl)));
                } else {
                    yield put(
                        push(Router.generate(routes.PROVIDER_DETAIL, { id: dataUser.id, tab: 'calendar', subId: '' })),
                    );
                }
                yield call(handleFetchUnconfirmed, actionSeance);
            } else {
                if (historyObj?.location?.state?.backUrl) {
                    yield put(push(Router.generate(historyObj?.location?.state?.backUrl)));
                } else {
                    yield put(push(Router.generate(routes.PROVIDERS_LIST)));
                }
            }
        }
    } catch (error) {
        yield UserAuthService.logout();
        yield put({
            type: failureType(type),
            error,
            sagaPayload: payload,
        });

        yield call(
            callbacks.reject,
            new SubmissionError({
                _error: error.message ?? 'Incorrect response',
            }),
        );
    }
}

function* handleUpdatePassword(action: AuthUpdatePasswordAction): Iterable<any> {
    const {
        type,
        payload: { data, callbacks },
        payload,
    } = action;
    yield put({ type: requestType(type) });

    try {
        const result: any = yield AuthApi.updatePassword(data);

        yield put({
            type: successType(type),
            payload: result,
            sagaPayload: payload,
        });
        yield call(callbacks.resolve);

        // Recovery token only allows setting the password; log in again with 2FA
        UserAuthService.logout();
        yield put(push(Router.generate(routes.LOGIN_CUSTOMER)));
        return;
        const actionSeance: GetSeancesAction = {
            type: SeanceActions.FETCH_UNCONFIRMED_SEANCES,
            payload: {},
        };

        const actionUser: GetProfileAction = {
            type: AuthActions.AUTH_GET_PROFILE,
            payload: {},
        };
        yield call(handleGetProfile, actionUser);

        if (user.getRoles().includes(UserRole.ROLE_ADMIN)) {
            yield put(push(Router.generate(routes.DASHBOARD)));
        } else {
            const dataUser: any = yield select((state: StoreState) => state.auth.data);
            if (dataUser.id && dataUser?.userProviders && !dataUser.userProviders.length) {
                yield put(
                    push(Router.generate(routes.PROVIDER_DETAIL, { id: dataUser.id, tab: 'calendar', subId: '' })),
                );
            } else {
                yield put(push(Router.generate(routes.PROVIDERS_LIST)));
                yield call(handleFetchUnconfirmed, actionSeance);
            }
        }
    } catch (error) {
        yield put({
            type: failureType(type),
            error,
            sagaPayload: payload,
        });

        yield call(
            callbacks.reject,
            new SubmissionError({
                _error: error?.message ?? 'Incorrect response',
            }),
        );
    }
}

function* handleCompleteReg(action: AuthCompleteRegAction): Iterable<any> {
    const {
        type,
        payload: { data, callbacks },
        payload,
    } = action;
    yield put({ type: requestType(type) });

    try {
        const result: any = yield AuthApi.completeRegistration(data.plainPassword, data.confirm, data.key)
            .catch(({ response }) => {
                return response;
            })
            .then((response) => {
                if (response?.status < 200 || response?.status >= 300) {
                    throw new Error('Incorrect email or password');
                }

                return response.data;
            });

        yield UserAuthService.login(result.token);

        yield put({
            type: successType(type),
            payload: result,
            sagaPayload: payload,
        });
        yield call(callbacks.resolve);
        const actionSeance: GetSeancesAction = {
            type: SeanceActions.FETCH_UNCONFIRMED_SEANCES,
            payload: {},
        };

        const actionUser: GetProfileAction = {
            type: AuthActions.AUTH_GET_PROFILE,
            payload: {},
        };
        yield call(handleGetProfile, actionUser);

        if (user.getRoles().includes(UserRole.ROLE_ADMIN)) {
            yield put(push(Router.generate(routes.DASHBOARD)));
        } else {
            const dataUser: any = yield select((state: StoreState) => state.auth.data);
            if (dataUser.id && dataUser.userProviders && !dataUser.userProviders.length) {
                yield put(
                    push(Router.generate(routes.PROVIDER_DETAIL, { id: dataUser.id, tab: 'calendar', subId: '' })),
                );
            } else {
                yield put(push(Router.generate(routes.PROVIDERS_LIST)));
                yield call(handleFetchUnconfirmed, actionSeance);
            }
        }
    } catch (error) {
        yield put({
            type: failureType(type),
            error,
            sagaPayload: payload,
        });

        yield call(
            callbacks.reject,
            new SubmissionError({
                _error: error.message ?? 'Incorrect response',
            }),
        );
    }
}
function* handleUserLogout(action: AuthLogoutAction): Iterable<any> {
    const { type } = action;

    yield put({ type: requestType(type) });

    try {
        yield UserAuthService.logout();
        // Redirect to the Home screen
        yield put(push(Router.generate(routes.LOGIN_CUSTOMER), {}));
        // Store request response to the Redux
        yield put({
            type: successType(type),
            payload: {},
            sagaPayload: {},
        });
        yield put({
            type: successType(SeanceActions.FETCH_UNCONFIRMED_SEANCES),
            payload: [],
            sagaPayload: {},
        });

    } catch (error) {
        yield put({
            type: failureType(type),
            error,
            sagaPayload: {},
        });

        yield handleError({
            error,
            sagaPayload: {},
        });
    }
}

// function* handleUserLogout(action: AuthLogoutAction): Iterable<any> {
//     const { type } = action;
//
//     yield put({ type: requestType(type) });
//
//     try {
//         yield UserAuthService.logout();
//
//         // Redirect to the Home screen
//         yield put(push(Router.generate(routes.HOME)));
//
//         // Store request response to the Redux
//         yield put({
//             type: successType(type),
//             payload: {},
//             sagaPayload: {},
//         });
//     } catch (error) {
//         yield put({
//             type: failureType(type),
//             error,
//             sagaPayload: {},
//         });
//
//         yield handleError({
//             error,
//             sagaPayload: {},
//         });
//     }
// }
//
// function* handleRequestPasswordReset(action: RequestPasswordResetAction): Iterable<any> {
//     const {
//         type,
//         payload: { status, callbacks },
//         payload,
//     } = action;
//     yield resolveApiCall(
//         action,
//         () => AuthApi.requestPasswordReset(status),
//         function* (result: ResolverApiSuccess) {
//             yield call(callbacks.resolve);
//             yield NavigationService.navigate(routes.PasswordRecovery.CheckResetPassword, { email: status.email });
//         },
//         function* (result: ResolverApiFailure) {
//             if (result.error && result.error.response && result.error.response.status) {
//                 yield call(
//                     callbacks.reject,
//                     new SubmissionError({
//                         _error: result.error.response.status.message,
//                     }),
//                 );
//             }
//             handleError(result);
//         },
//     );
// }
//
// function* handleUpdatePassword(action: UpdatePasswordAction): Iterable<any> {
//     const {
//         type,
//         payload: { status, callbacks },
//         payload,
//     } = action;
//
//     const token = KeyValueStorageService.get('password-reset-token', true);
//
//     yield resolveApiCall(
//         action,
//         () => AuthApi.updatePassword(status, token),
//         function* (result: ResolverApiSuccess) {
//             yield call(callbacks.resolve);
//
//             yield UserAuthService.repairByData(token);
//
//             yield NavigationService.resetStackAction([{ routeName: routes.Account }]);
//         },
//         function* (result: ResolverApiFailure) {
//             if (result.error && result.error.response && result.error.response.status) {
//                 yield call(
//                     callbacks.reject,
//                     new SubmissionError({
//                         _error: result.error.response.status.message,
//                     }),
//                 );
//             }
//             handleError(result);
//         },
//     );
// }
//
// function* handleCheckResetCode(action: CheckResetCodeAction): Iterable<any> {
//     const {
//         type,
//         payload: { status, callbacks },
//         payload,
//     } = action;
//     yield resolveApiCall(
//         action,
//         () => AuthApi.checkResetCode(status),
//         function* (result: ResolverApiSuccess) {
//             yield call(callbacks.resolve);
//
//             const {
//                 payload: { token },
//             } = result;
//             KeyValueStorageService.set('password-reset-token', token);
//
//             yield NavigationService.navigate(routes.PasswordRecovery.UpdatePassword, { email: status.email });
//         },
//         function* (result: ResolverApiFailure) {
//             if (result.error && result.error.response && result.error.response.status) {
//                 yield call(
//                     callbacks.reject,
//                     new SubmissionError({
//                         _error: result.error.response.status.message,
//                     }),
//                 );
//             }
//             handleError(result);
//         },
//     );
// }

function* handleRecoveryPasswordRequest(action: AuthResetPasswordRequestAction): Iterable<any> {
    const {
        payload: { data, callbacks },
    } = action;

    if (data.username) {
        data.username = data.username.toLowerCase();
    }

    yield resolveApiCall(
        action,
        () => AuthApi.resetPasswordRequest(data),
        function* (data: ResolverApiSuccess) {
            yield call(callbacks.resolve);
        },
        function* (result: ResolverApiFailure) {
            if (result?.error && result?.error?.response && result?.error?.response?.status) {
                yield call(
                    callbacks.reject,
                    result?.error instanceof SubmissionError
                        ? result?.error
                        : new SubmissionError({
                              // _error: result.error.message ?? 'Incorrect response',
                              ...makeFormErrorsWithMessage(result?.error?.response?.data),
                          }),
                );
            }
            yield handleError(result);
        },
    );
}

function* handleValidateRecoveryCode(action: AuthValidateRecoveryCodeAction): Iterable<any> {
    const {
        type,
        payload: { data, callbacks },
        payload,
    } = action;
    yield put({ type: requestType(type) });

    try {
        const result: any = yield AuthApi.validateResetPasswordToken(data)
            .catch(({ response }) => {
                return response;
            })
            .then((response) => {
                if (response?.status < 200 || response?.status >= 300) {
                    throw new Error('Invalid code');
                }

                return response.data;
            });

        yield UserAuthService.login(result.token);

        yield put({
            type: successType(type),
            payload: result,
            sagaPayload: payload,
        });

        yield call(callbacks.resolve);
    } catch (error) {
        yield put({
            type: failureType(type),
            error,
            sagaPayload: payload,
        });

        yield call(
            callbacks.reject,
            new SubmissionError({
                _error: error.message ?? 'Incorrect response',
            }),
        );
    }
}

export default function* () {
    yield takeLatest(AuthActions.AUTH_LOGIN, handleLogin);
    yield takeLatest(AuthActions.AUTH_LOGIN_CODE, handleLoginCode);
    yield takeLatest(AuthActions.AUTH_LOGOUT, handleUserLogout);
    yield takeLatest(AuthActions.AUTH_GET_PROFILE, handleGetProfile);
    yield takeLatest(AuthActions.AUTH_REQUEST_PASSWORD_RESET, handleRecoveryPasswordRequest);
    yield takeLatest(AuthActions.AUTH_CHECK_RESET_CODE, handleValidateRecoveryCode);
    yield takeLatest(AuthActions.AUTH_UPDATE_PASSWORD, handleUpdatePassword);
    yield takeLatest(AuthActions.AUTH_COMPLETE_REGISTRATION, handleCompleteReg);
}
